// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"form-checkbox_checkbox__BCiep","active":"form-checkbox_active__9K8B0"};